import { useMemo } from "react";
import { useTranslation } from "react-i18next";
const k = {
    invoice: "use-pages-i18n.invoice",
    dynamicInvoiceList: "use-pages-i18n.dynamicInvoiceList"
};
export const translations = {
    da: {
        invoice: "Fakturering",
        dynamicInvoiceList: "Godkend fakturaforslag"
    },
    en: {
        invoice: "Invoice",
        dynamicInvoiceList: "Approve prepared invoice"
    }
};
export const useT = () => {
    const { t, i18n } = useTranslation();
    const localT = useMemo(() => ({
        invoice: t(k.invoice),
        dynamicInvoiceList: t(k.dynamicInvoiceList)
    }), [i18n.language]);
    return useMemo(() => ({ t: localT, i18n }), [localT, i18n]);
};
